import { defineCustomElement } from 'vue'
import router from './infrastructure/router.ts';
import i18n from './infrastructure/i18n.ts';
import App from './App.vue'
import styles_datepicker from '@vuepic/vue-datepicker/dist/main.css?raw'
let styles_datepicker_local = styles_datepicker
    .replaceAll(":root", ":host"); // Ersetze root durch host da in Webcomponen

import iwayStyles from './styles.iway.css?inline'

const GfoCheckout = defineCustomElement(App, {
  configureApp(app) {
    app.use(router)
    app.use(i18n)
  },
  styles: [styles_datepicker_local, iwayStyles],
})

customElements.define('gfo-checkout', GfoCheckout)
